// Mirror of api/src/freeEmailDomains.ts — kept in sync by hand.
// Used for fast inline UX feedback. Backend is authoritative.

export const freeEmailDomains: ReadonlySet<string> = new Set([
  "gmail.com",
  "googlemail.com",
  "outlook.com",
  "outlook.fr",
  "outlook.de",
  "outlook.es",
  "outlook.it",
  "outlook.com.br",
  "outlook.pt",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "hotmail.de",
  "hotmail.es",
  "hotmail.it",
  "hotmail.com.br",
  "live.com",
  "live.co.uk",
  "live.fr",
  "live.de",
  "msn.com",
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "yahoo.fr",
  "yahoo.de",
  "yahoo.es",
  "yahoo.it",
  "yahoo.com.br",
  "ymail.com",
  "rocketmail.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "aol.com",
  "aim.com",
  "protonmail.com",
  "proton.me",
  "pm.me",
  "tutanota.com",
  "tuta.io",
  "gmx.com",
  "gmx.net",
  "gmx.de",
  "gmx.us",
  "mail.com",
  "email.com",
  "yandex.com",
  "yandex.ru",
  "qq.com",
  "163.com",
  "126.com",
  "sina.com",
  "naver.com",
  "web.de",
  "t-online.de",
  "freenet.de",
  "uol.com.br",
  "bol.com.br",
  "terra.com.br",
  "ig.com.br",
  "fastmail.com",
  "fastmail.fm",
  "hey.com",
  "zoho.com",
  "inbox.com",
  "lycos.com",
  "rediffmail.com",
  "mail.ru",
  "rambler.ru",
  "mailinator.com",
  "guerrillamail.com",
  "10minutemail.com",
  "trashmail.com",
  "yopmail.com",
  "tempmail.com",
  "throwawaymail.com",
]);

export function isFreeEmailDomain(email: string): boolean {
  const at = email.lastIndexOf("@");
  if (at < 0) return false;
  const domain = email.slice(at + 1).trim().toLowerCase();
  return freeEmailDomains.has(domain);
}
